import { Injectable, Injector, InjectionToken, Inject } from '@angular/core';
import { LoginProvider } from '../models/login-provider';


export const EXTERNAL_LOGIN_PROVIDERS = new InjectionToken<LoginProvider[]>('EXTERNAL_LOGIN_PROVIDERS');

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  public providers: Array<LoginProvider> = [];

  private _activeProviders: Array<any>;
  public get activeProviders(): Array<any> {
    if (!this._activeProviders) {
      this._activeProviders = this.providers.filter(m => m.isActive === true) || [];
    }
    return this._activeProviders;
  }

  constructor(
    private injector: Injector) {

    const providers = this.injector.get(EXTERNAL_LOGIN_PROVIDERS, []);

    if (providers instanceof Array) {
      this.providers = providers;
    } else {
      this.providers.push(providers);
    }
  }

  public login(provider: LoginProvider, event: Event) {
    event.preventDefault();
    event.stopPropagation();
    provider.authenticate();
  }
}
